
export const enCommon = {
  // Header
  home: "Home",
  services: "Services",
  reservation: "Reservation",
  about: "About Us",
  blog: "Blog",
  contact: "Contact",
  myReservation: "My Reservations",
  
  // Hero
  heroTitle: "Make Your Holiday in Turkey Unforgettable",
  heroSubtitle: "Transfer, Private Tours, Boat Tours, Car Rental and more…",
  
  // Services
  transferService: "Transfer Service",
  privateTours: "Private Tours",
  groupTours: "Group Tours",
  boatTours: "Yacht Rental",
  carRental: "Car Rental",
  villaRental: "Villa Rental",
  
  // Transfer Page
  transferServices: "Transfer Services",
  transferHeroDesc: "Comfortable travel experience with airport transfer, intercity transfer and VIP welcome services",
  transferOptions: "Our Transfer Options",
  transferOptionsDesc: "Choose the transfer service that suits your needs",
  airportHotel: "Airport - Hotel",
  airportHotelDesc: "Comfortable transfer from airport to your hotel",
  hotelAirport: "Hotel - Airport",
  hotelAirportDesc: "Safe transfer from your hotel to airport",
  intercityTransfer: "Intercity Transfer",
  intercityTransferDesc: "Transfer service to anywhere in Turkey",
  vipWelcome: "VIP Welcome",
  vipWelcomeDesc: "Special welcome and VIP transfer service",
  chauffeurService: "Hourly Chauffeur Service",
  chauffeurServiceDesc: "Professional chauffeur-driven hourly car rental service, ideal for city tours and special events",
  ourFleet: "Our Fleet",
  ourFleetDesc: "Luxury and comfortable vehicles suitable for your needs",
  economySedanName: "Economy Sedan",
  comfortSedanName: "Comfort Sedan",
  mercedesVitoName: "Mercedes Vito VIP",
  mercedesSprinterName: "Mercedes Sprinter",
  minibusName: "Minibus 15+1",
  busName: "Bus 46 Seats",
  passengers: "Passengers",
  luggage: "Luggage",
  airConditioning: "Air Conditioning",
  comfortableSeats: "Comfortable Seats",
  experiencedDriver: "Experienced Driver",
  premiumAC: "Premium AC",
  leatherSeats: "Leather Seats",
  vipDriver: "VIP Driver",
  waterService: "Water Service",
  vipInterior: "VIP Interior",
  largeLuggage: "Large Luggage",
  premiumComfort: "Premium Comfort",
  refreshmentService: "Refreshment Service",
  spaciousInterior: "Spacious Interior",
  comfortableJourney: "Comfortable Journey",
  professionalDriver: "Professional Driver",
  wideSeats: "Wide Seats",
  luggageCompartment: "Luggage Compartment",
  premiumSeats: "Premium Seats",
  wcAvailable: "WC",
  tvAvailable: "TV",
  largeLuggageSpace: "Large Luggage Space",
  
  // Reservation Form
  transferReservation: "Transfer Reservation",
  transferType: "Transfer Type",
  selectTransferType: "Select transfer type",
  from: "From",
  to: "To",
  departurePoint: "Departure point",
  arrivalPoint: "Arrival point",
  date: "Date",
  time: "Time",
  flightCode: "Flight Code (Optional)",
  flightCodePlaceholder: "E.g: TK1234",
  passengerInfo: "Passenger Information",
  addPassenger: "Add Passenger",
  firstName: "First Name",
  lastName: "Last Name",
  phoneNumber: "Phone Number",
  phonePlaceholder: "+90 555 123 45 67",
  luggageCount: "Luggage Count",
  childSeat: "Child Seat",
  notNeeded: "Not Needed",
  pieces: "Pieces",
  vehicleSelection: "Vehicle Selection",
  selectVehicle: "Select vehicle",
  roundTrip: "Round Trip Transfer",
  extraInfo: "Extra Information",
  extraInfoPlaceholder: "Your special requests or notes...",
  maxCharacters: "Maximum 500 characters",
  makeReservation: "Make Reservation",
  dailyRental: "Daily Rental",
  dailyRentalDesc: "Comfortable city and intercity travel with professional chauffeur-driven daily car rental service",
  
  // Voucher
  reservationConfirmed: "Your Reservation is Confirmed!",
  voucherSent: "Your voucher information has been sent to your email address.",
  voucherNumber: "Voucher Number",
  secretCode: "Secret Code",
  voucherNote: "You can use your voucher number and secret code for cancellation or modification.",
  backToHome: "Back to Home",
  downloadVoucher: "Download Voucher",
  
  // My Reservations
  myReservations: "My Reservations",
  checkReservation: "Check Reservation",
  enterVoucherInfo: "Enter your voucher number and secret code for cancellation or modification",
  enterVoucherNumber: "Enter your voucher number",
  enterSecretCode: "Enter your secret code",
  searchReservation: "Search Reservation",
  reservationDetails: "Reservation Details",
  reservationStatus: "Status",
  serviceType: "Service Type",
  reservationDate: "Reservation Date",
  totalPrice: "Total Price",
  cancelReservation: "Cancel Reservation",
  modifyReservation: "Modify Reservation",
  statusActive: "Active",
  statusCancelled: "Cancelled",
  statusCompleted: "Completed",
  confirmCancel: "Are you sure you want to cancel this reservation?",
  cancelSuccess: "Reservation cancelled successfully",
  cancelError: "An error occurred during cancellation",
  notFound: "Reservation not found",
  invalidCredentials: "Invalid voucher number or secret code",
  
  // Quick Booking Form
  selectService: "Select Service",
  searchContinue: "SEARCH / CONTINUE",
  
  // Why Us
  whyUs: "Why Us?",
  personalizedExperience: "Personalized Travel Experience",
  personalizedDesc: "We offer customized travel plans for each of our customers",
  wideDestinations: "Wide Destinations",
  wideDestinationsDesc: "Transportation and tour services to the most beautiful places in Turkey",
  comfortSafety: "Comfort & Safety",
  comfortSafetyDesc: "Safe journey with luxury vehicles and professional drivers",
  support247: "24/7 Support",
  support247Desc: "We are always with you, uninterrupted customer support",
  
  // Footer
  companyDesc: "Liberty Tour provides transfer, tour and car rental services throughout Turkey, based in Antalya.",
  quickLinks: "Quick Links",
  ourServices: "Our Services",
  supportLine: "Support Line",
  followUs: "Follow Us",
  allRightsReserved: "All rights reserved",
  privacyPolicy: "Privacy Policy",
  termsConditions: "Terms & Conditions",
  
  // Common
  bookNow: "Book Now",
  learnMore: "Learn More",
  viewAll: "View All",
  currency: "Currency",
  price: "Price",
  book: "Book",
  email: "Email",
  emailPlaceholder: "example@email.com",
  
  // Services Page
  servicesPageTitle: "Our Services",
  servicesPageDesc: "Special services for you in the most beautiful destinations of Turkey",
  
  // Private Tours Page
  privateToursTitle: "Private Tours",
  privateToursDesc: "Customized tour programs and professional guided tours",
  popularTours: "Our Popular Tours",
  discoverTurkey: "Discover the most beautiful destinations of Turkey",
  tourReservation: "Tour Reservation",
  tourSelection: "Tour Selection",
  selectTour: "Select tour",
  duration: "Duration",
  highlights: "Highlights",
  included: "Included",
  specialRequests: "Special Requests",
  moreInfo: "More Info",
  
  // Tour 1: Antalya City Tour
  tour1Name: "Antalya City Tour",
  tour1Duration: "Full Day (8 Hours)",
  tour1Price: "€35 per person",
  tour1Highlight1: "Kaleiçi Old Town",
  tour1Highlight2: "Hadrian's Gate",
  tour1Highlight3: "Düden Waterfalls",
  tour1Highlight4: "Antalya Museum",
  tour1Include1: "Professional guide",
  tour1Include2: "Lunch",
  tour1Include3: "Entrance fees",
  tour1Include4: "Hotel transfers",
  tour1Description: "Explore the historic heart of Antalya with its charming old town, ancient Roman gates, and stunning waterfalls. This tour offers a perfect blend of history, culture, and natural beauty. Ideal for history enthusiasts, photographers, and families who want to discover the authentic charm of the Mediterranean coast.",
  
  // Tour 2: Cappadocia
  tour2Name: "Cappadocia 2-Day Tour",
  tour2Duration: "2 Days / 1 Night",
  tour2Price: "€120 per person",
  tour2Highlight1: "Hot air balloon ride",
  tour2Highlight2: "Underground cities",
  tour2Highlight3: "Göreme Open Air Museum",
  tour2Highlight4: "Fairy chimneys",
  tour2Include1: "Round-trip flights",
  tour2Include2: "Hotel accommodation",
  tour2Include3: "All meals",
  tour2Include4: "Professional guide",
  tour2Include5: "Entrance fees",
  tour2Description: "Experience the magical landscape of Cappadocia with its unique rock formations and underground cities. Watch the sunrise from a hot air balloon and explore ancient cave churches. Perfect for adventure seekers, couples looking for romance, and anyone who wants to witness one of the world's most extraordinary landscapes.",
  
  // Tour 3: Pamukkale
  tour3Name: "Pamukkale & Hierapolis",
  tour3Duration: "Full Day (10 Hours)",
  tour3Price: "€50 per person",
  tour3Highlight1: "White travertine terraces",
  tour3Highlight2: "Ancient Hierapolis",
  tour3Highlight3: "Cleopatra's Pool",
  tour3Include1: "Professional guide",
  tour3Include2: "Lunch",
  tour3Include3: "Entrance fees",
  tour3Include4: "Hotel transfers",
  tour3Description: "Discover the stunning white calcium terraces of Pamukkale and the ancient Roman city of Hierapolis. Walk barefoot on the warm travertines and swim in the legendary Cleopatra's Pool. This tour is perfect for nature lovers, wellness enthusiasts, and those interested in ancient civilizations and natural wonders.",
  
  // Tour 4: Istanbul
  tour4Name: "Istanbul Highlights",
  tour4Duration: "2 Days / 1 Night",
  tour4Price: "€150 per person",
  tour4Highlight1: "Blue Mosque",
  tour4Highlight2: "Hagia Sophia",
  tour4Highlight3: "Topkapi Palace",
  tour4Highlight4: "Grand Bazaar",
  tour4Include1: "Round-trip flights",
  tour4Include2: "Hotel accommodation",
  tour4Include3: "Professional guide",
  tour4Include4: "Entrance fees",
  tour4Description: "Immerse yourself in the rich history and vibrant culture of Istanbul, where East meets West. Visit iconic landmarks, explore bustling bazaars, and experience the unique atmosphere of this magnificent city. Ideal for culture enthusiasts, history buffs, and travelers who want to experience the crossroads of civilizations.",
  
  // Tour 5: Perge & Aspendos
  tour5Name: "Perge & Aspendos Ancient Cities",
  tour5Duration: "Full Day (7 Hours)",
  tour5Price: "€40 per person",
  tour5Highlight1: "Perge Ancient City",
  tour5Highlight2: "Aspendos Theater",
  tour5Highlight3: "Roman architecture",
  tour5Include1: "Professional guide",
  tour5Include2: "Lunch",
  tour5Include3: "Entrance fees",
  tour5Include4: "Hotel transfers",
  tour5Description: "Step back in time to explore two of the best-preserved ancient cities in Turkey. Marvel at the magnificent Roman theater of Aspendos and walk through the ruins of Perge. This tour is perfect for archaeology enthusiasts, history lovers, and families interested in ancient civilizations and classical architecture.",
  
  // Tour 6: Ephesus
  tour6Name: "Ephesus Ancient City",
  tour6Duration: "Full Day (12 Hours)",
  tour6Price: "€80 per person",
  tour6Highlight1: "Library of Celsus",
  tour6Highlight2: "Great Theater",
  tour6Highlight3: "Temple of Artemis",
  tour6Include1: "Professional guide",
  tour6Include2: "Lunch",
  tour6Include3: "Entrance fees",
  tour6Include4: "Hotel transfers",
  tour6Description: "Visit one of the most magnificent ancient cities of the classical world. Walk the marble streets where ancient Romans once walked and see the stunning Library of Celsus. This tour is ideal for history enthusiasts, archaeology lovers, and anyone fascinated by ancient Greek and Roman civilizations.",
  
  // Tour 7: Antalya Aquarium
  tour7Name: "Antalya Aquarium",
  tour7Duration: "4 Hours",
  tour7Price: "€40 per person",
  tour7Highlight1: "World's largest tunnel aquarium",
  tour7Highlight2: "Tropical fish species",
  tour7Highlight3: "Interactive exhibits",
  tour7Highlight4: "Snow World experience",
  tour7Include1: "Entrance tickets",
  tour7Include2: "Hotel transfers",
  tour7Include3: "Professional guide",
  tour7Description: "Dive into an underwater world at one of the world's largest aquarium complexes. Walk through the spectacular tunnel aquarium surrounded by sharks and rays, and explore diverse marine ecosystems. Perfect for families with children, marine life enthusiasts, and anyone looking for an educational and entertaining experience.",
  
  // Tour 8: Tazı Canyon
  tour8Name: "Tazı Canyon",
  tour8Duration: "6 Hours",
  tour8Price: "€45 per person",
  tour8Highlight1: "400m deep canyon views",
  tour8Highlight2: "Stunning panoramic vistas",
  tour8Highlight3: "Nature photography",
  tour8Highlight4: "Hiking trails",
  tour8Include1: "Professional guide",
  tour8Include2: "Lunch",
  tour8Include3: "Hotel transfers",
  tour8Description: "Experience the breathtaking beauty of Tazı Canyon, one of Turkey's most spectacular natural wonders. Stand at the edge of the 400-meter deep gorge and enjoy panoramic views of the Taurus Mountains. This tour is perfect for nature lovers, photographers, adventure seekers, and anyone who appreciates dramatic landscapes.",
  
  // Tour 9: St. Nicholas Memorial Museum
  tour9Name: "St. Nicholas Memorial Museum",
  tour9Duration: "5 Hours",
  tour9Price: "€50 per person",
  tour9Highlight1: "Original Santa Claus Church",
  tour9Highlight2: "Byzantine architecture",
  tour9Highlight3: "Myra Ancient City",
  tour9Highlight4: "Rock-cut tombs",
  tour9Include1: "Professional guide",
  tour9Include2: "Lunch",
  tour9Include3: "Entrance fees",
  tour9Include4: "Hotel transfers",
  tour9Description: "Visit the birthplace of the legend of Santa Claus and explore the ancient church of St. Nicholas in Demre. Discover Byzantine frescoes and the nearby ancient city of Myra with its impressive rock tombs. Ideal for families, history enthusiasts, cultural travelers, and those interested in Christian heritage and ancient civilizations.",
  
  // Tour 10: Köprülü Canyon
  tour10Name: "Tripl Park Köprülü Canyon",
  tour10Duration: "8 Hours",
  tour10Price: "€65 per person",
  tour10Highlight1: "White water rafting",
  tour10Highlight2: "Zipline adventure",
  tour10Highlight3: "Canyon hiking",
  tour10Highlight4: "Adventure park activities",
  tour10Include1: "All equipment",
  tour10Include2: "Professional instructors",
  tour10Include3: "Lunch",
  tour10Include4: "Insurance",
  tour10Include5: "Hotel transfers",
  tour10Description: "Get your adrenaline pumping with an action-packed day at Köprülü Canyon. Experience thrilling white water rafting, soar through the air on ziplines, and enjoy various adventure activities in stunning natural surroundings. Perfect for adventure seekers, active travelers, groups of friends, and families with teenagers looking for excitement.",
  
  // Tour 11: Olympos - Çıralı
  tour11Name: "Olympos – Çıralı",
  tour11Duration: "8 Hours",
  tour11Price: "€55 per person",
  tour11Highlight1: "Ancient Olympos ruins",
  tour11Highlight2: "Pristine Çıralı beach",
  tour11Highlight3: "Yanartaş eternal flames",
  tour11Highlight4: "Sea turtle nesting area",
  tour11Include1: "Professional guide",
  tour11Include2: "Lunch",
  tour11Include3: "Entrance fees",
  tour11Include4: "Hotel transfers",
  tour11Description: "Explore the mystical ruins of ancient Olympos nestled in a lush valley, relax on the unspoiled Çıralı beach, and witness the eternal flames of Yanartaş. This unique tour combines history, nature, and mythology. Perfect for nature lovers, beach enthusiasts, families, and those seeking a peaceful escape with cultural depth.",
  
  // Tour 12: Land of Legends
  tour12Name: "Land of Legends",
  tour12Duration: "8 Hours",
  tour12Price: "€70 per person",
  tour12Highlight1: "Spectacular water slides",
  tour12Highlight2: "Theme park attractions",
  tour12Highlight3: "Shopping avenue",
  tour12Highlight4: "Entertainment shows",
  tour12Include1: "Park entrance",
  tour12Include2: "Hotel transfers",
  tour12Include3: "Professional guide",
  tour12Description: "Experience the ultimate entertainment destination with thrilling water slides, exciting theme park rides, and spectacular shows. Explore the luxury shopping avenue and enjoy world-class entertainment. This tour is perfect for families with children, thrill-seekers, groups of friends, and anyone looking for a fun-filled day of excitement and entertainment.",
  
  // Group Tours Page
  groupToursTitle: "Group Tours",
  groupToursDesc: "Group tours and daily excursions at economical prices",
  groupTypesTitle: "Our Group Types",
  groupTypesDesc: "Special solutions for every group",
  schoolGroups: "School Groups",
  schoolGroupsDesc: "Educational and fun school trips",
  corporateTrips: "Corporate Trips",
  corporateTripsDesc: "Corporate events and team building",
  familyGroups: "Family Groups",
  familyGroupsDesc: "Large family gatherings and special occasions",
  capacity: "Capacity",
  educationalGuide: "Educational Guide",
  safeTransfer: "Safe Transfer",
  lunch: "Lunch",
  insurance: "Insurance",
  professionalOrganization: "Professional Organization",
  luxuryVehicles: "Luxury Vehicles",
  catering: "Catering",
  activities: "Activities",
  flexibleProgram: "Flexible Program",
  childFriendly: "Child Friendly",
  specialMenu: "Special Menu",
  photoService: "Photo Service",
  groupPackagesTitle: "Our Group Packages",
  groupPackagesDesc: "Group discounts with special prices",
  noPackagesYet: "No Packages Yet",
  packagesComingSoon: "Group packages will be added soon",
  hideInfo: "Hide Info",
  getQuote: "Get Quote",
  groupTourRequest: "Group Tour Request",
  groupType: "Group Type",
  selectGroupType: "Select group type",
  schoolGroup: "School Group",
  corporateGroup: "Corporate Group",
  familyGroup: "Family Group",
  groupNameOrCompany: "Group Name / Company Name",
  groupNamePlaceholder: "Group or company name",
  participantCount: "Number of Participants",
  authorizedPerson: "Contact Person Name",
  authorizedPersonPlaceholder: "Full Name",
  phoneLabel: "Phone",
  emailLabel: "Email",
  preferredDate: "Preferred Date",
  tourDuration: "Tour Duration",
  selectDuration: "Select duration",
  halfDay: "Half Day",
  fullDay: "Full Day",
  multiDay: "Multi-Day",
  specialRequestsDetails: "Special Requests and Details",
  specialRequestsPlaceholder: "Details about the group, special requests, budget information...",
  maxChars: "Maximum 500 characters",
  processing: "Processing...",
  sendQuoteRequest: "Send Quote Request",
  
  // Car Rental Page
  carRentalTitle: "Car Rental",
  carRentalDesc: "Safe and comfortable car rental service in Antalya",
  carCategoriesTitle: "Our Car Categories",
  carCategoriesDesc: "Choose the right car for your needs",
  rentalAdvantagesTitle: "Rental Advantages",
  rentalAdvantagesDesc: "Safe and comfortable rental experience",
  fullInsurance: "Full Insurance",
  fullInsuranceDesc: "Comprehensive insurance options",
  flexibleDelivery: "Flexible Delivery",
  flexibleDeliveryDesc: "Airport, hotel or city center",
  support247: "24/7 Support",
  support247Desc: "We are always with you",
  affordablePrice: "Affordable Price",
  affordablePriceDesc: "Weekly and monthly discounts",
  carRentalReservation: "Car Rental Reservation",
  carCategory: "Car Category",
  selectCarCategory: "Select car category",
  perDay: "day",
  pickupDate: "Pickup Date",
  pickupTime: "Pickup Time",
  returnDate: "Return Date",
  returnTime: "Return Time",
  pickupLocation: "Pickup Location",
  selectPickupLocation: "Select pickup location",
  returnLocation: "Return Location",
  selectReturnLocation: "Select return location",
  airport: "Antalya Airport",
  cityCenter: "City Center",
  hotelDelivery: "Hotel Delivery",
  other: "Other",
  fullName: "Full Name",
  phone: "Phone",
  email: "Email",
  fullInsuranceExtra: "Full Insurance (+15€/day)",
  gpsNavigation: "GPS Navigation (+5€/day)",
  childSeat: "Child Seat (+3€/day)",
  specialRequests: "Special Requests",
  specialRequestsPlaceholder: "Your special requests or notes...",
  maxCharacters: "Maximum 500 characters",
  makeReservation: "Make Reservation",
  processing: "Processing...",
  noCarsYet: "No Cars Yet",
  carsSoonAdded: "Cars will be added soon",
  daily: "Daily",
  
  // Villa Rental Page
  villaRentalTitle: "Villa Rental",
  villaRentalDesc: "Luxury beachfront villas and private pool holiday homes",
  ourVillas: "Our Villas",
  luxuryVillas: "Luxury and comfortable villas",
  villaReservation: "Villa Rental Reservation",
  checkIn: "Check-in Date",
  checkOut: "Check-out Date",
  guests: "Number of Guests",
  bedrooms: "Bedrooms",
  bathrooms: "Bathrooms",
  privatePool: "Private Pool",
  seaView: "Sea View",
  garden: "Garden",
  parking: "Parking",
  wifi: "WiFi",
  kitchen: "Kitchen",
  villaCategories: "Villa Categories",
  selectSuitableVilla: "Choose the villa that suits you",
  people: "People",
  night: "Night",
  details: "Details",
  villaCategory: "Villa Category",
  selectCategory: "Select category",
  checkInDate: "Check-in Date",
  checkOutDate: "Check-out Date",
  adultsCount: "Number of Adults",
  childrenCount: "Number of Children",
  fullName: "Full Name",
  fullNamePlaceholder: "Your first and last name",
  phone: "Phone",
  email: "Email",
  emailPlaceholder: "example@email.com",
  specialRequests: "Special Requests",
  specialRequestsPlaceholder: "Your special requests or notes...",
  maxCharacters: "Maximum 500 characters",
  processing: "Processing...",
  makeReservation: "Make Reservation",
  
  // Yacht Rental Page
  yachtRentalTitle: "Yacht Rental",
  yachtRentalDesc: "Unforgettable sea experience with luxury yachts and private boat tours",
  ourYachts: "Our Yacht Fleet",
  luxuryYachts: "Luxury yachts and boats for sea pleasure",
  yachtReservation: "Yacht Rental Reservation",
  tourDate: "Tour Date",
  tourDuration: "Tour Duration",
  selectDuration: "Select duration",
  halfDay: "Half Day (4 Hours)",
  fullDay: "Full Day (8 Hours)",
  sunset: "Sunset (2 Hours)",
  crew: "Crew",
  captain: "Captain",
  meals: "Meals",
  drinks: "Drinks",
  fishingEquipment: "Fishing Equipment",
  snorkelingGear: "Snorkeling Gear",
  musicSystem: "Music System",
  yachtFleet: "Our Yacht Fleet",
  yachtFleetDesc: "Luxury yachts and boats for sea pleasure",
  boatTours: "Boat Tours",
  boatToursDesc: "Daily boat tours and special organizations",
  noYachtsYet: "No Yachts Yet",
  yachtsComingSoon: "Yachts will be added soon",
  noToursYet: "No Tours Yet",
  toursComingSoon: "Tours will be added soon",
  yachtType: "Yacht Type",
  selectYachtType: "Select yacht type",
  motorYacht: "Motor Yacht",
  sailingYacht: "Sailing Yacht",
  catamaran: "Catamaran",
  megaYacht: "Mega Yacht",
  dailyTour: "Daily Tour",
  sunsetTour: "Sunset Tour",
  startDate: "Start Date",
  endDate: "End Date",
  departurePort: "Departure Port",
  selectPort: "Select port",
  antalyaMarina: "Antalya Marina",
  kasPort: "Kas Port",
  kalkanPort: "Kalkan Port",
  fethiyeMarina: "Fethiye Marina",
  bodrumMarina: "Bodrum Marina",
  passengerCount: "Number of Passengers",
  fullNameLabel: "Full Name",
  fullNamePlaceholder: "Full Name",
  phoneLabel: "Phone",
  phonePlaceholder: "+90 555 123 45 67",
  emailLabel: "Email",
  emailPlaceholder: "example@email.com",
  cateringService: "Catering Service",
  waterSportsEquipment: "Water Sports Equipment (Jet Ski, Snorkel)",
  professionalCrew: "Professional Crew",
  specialRequests: "Special Requests",
  specialRequestsPlaceholder: "Route preferences, special requests...",
  maxCharacters: "Maximum 500 characters",
  processing: "Processing...",
  makeReservation: "Make Reservation",
  rent: "Rent",
  perDay: "/Day",
  perHour: "/Hour",
  perPerson: "/Person",
  
  // About Page
  aboutSubtitle: "Reliable and quality tourism services in Turkey since 2019",
  ourStory: "Our Story",
  storyParagraph1: "Liberty Tour, founded in Antalya in 2019, is one of Turkey's leading tourism companies. Since our establishment, we have been a pioneer in the industry with our quality and reliable service approach, always prioritizing customer satisfaction.",
  storyParagraph2: "With over 6 years of experience, we have served more than 285,000 happy customers. With our modern fleet of over 45 vehicles, we offer a wide range of services from airport transfers to private tours, car rentals to villa reservations.",
  storyParagraph3: "With our 24/7 uninterrupted customer support and professional team, we are with you at every moment of your vacation. Security, comfort and customer satisfaction are our most important values.",
  yearsExperience: "Years Experience",
  happyCustomers: "Happy Customers",
  vehicleFleet: "Vehicle Fleet",
  support: "Support",
  ourMission: "Our Mission",
  missionText: "To make our customers' holidays in Turkey unforgettable by providing the highest quality tourism services. To perfect the travel experience with safe, comfortable and personalized solutions.",
  ourVision: "Our Vision",
  visionText: "To be Turkey's most reliable and preferred tourism company. To maintain our leading position in the industry with our innovative service approach and customer-oriented approach.",
  ourValues: "Our Values",
  valuesSubtitle: "The core values that make us who we are",
  valueSecurity: "Security",
  valueSecurityDesc: "The safety of our customers comes first. All our vehicles are regularly maintained and insured.",
  valueCustomerFocus: "Customer Focus",
  valueCustomerFocusDesc: "Customer satisfaction is our priority. We produce special solutions for each of our customers.",
  valueQuality: "Quality",
  valueQualityDesc: "We constantly improve ourselves to provide service at the highest quality standards.",
  valueProfessionalism: "Professionalism",
  valueProfessionalismDesc: "We always strive to provide the best service with our experienced and professional team.",
  valueInnovation: "Innovation",
  valueInnovationDesc: "We follow innovations in the industry and constantly improve our services.",
  valueHonesty: "Honesty",
  valueHonestyDesc: "We earn the trust of our customers with our transparent and honest business approach.",
  
  // Blog Page
  blogSubtitle: "Travel tips, destination guides and tourism news",
  blogPost1Title: "Top 10 Places to Visit in Antalya",
  blogPost1Excerpt: "Antalya's most beautiful beaches, ancient cities and natural beauties. Places you must see during your vacation.",
  blogPost1Date: "January 15, 2024",
  blogPost2Title: "Things to Consider in Airport Transfer",
  blogPost2Excerpt: "All the details and tips you need to know for a safe and comfortable airport transfer.",
  blogPost2Date: "January 10, 2024",
  blogPost3Title: "Boat Tour Guide: Pearls of the Mediterranean",
  blogPost3Excerpt: "The most beautiful boat tours you can do on the Antalya coast and the bays to see.",
  blogPost3Date: "January 5, 2024",
  blogPost4Title: "Car Rental Tips and Tricks",
  blogPost4Excerpt: "What you need to pay attention to when renting a car on vacation and ways to find the best prices.",
  blogPost4Date: "December 28, 2023",
  blogPost5Title: "Turkey's Most Beautiful Private Tour Routes",
  blogPost5Excerpt: "Turkey's most impressive tour routes from Cappadocia to Pamukkale, Ephesus to Kas.",
  blogPost5Date: "December 20, 2023",
  blogPost6Title: "Villa Holiday Planning: What You Need to Know",
  blogPost6Excerpt: "What you need to pay attention to before and after booking for a perfect villa holiday.",
  blogPost6Date: "December 15, 2023",
  blogCategoryGuide: "Guide",
  blogCategoryTransfer: "Transfer",
  blogCategoryYacht: "Yacht Tours",
  blogCategoryCarRental: "Car Rental",
  blogCategoryPrivateTours: "Private Tours",
  blogCategoryVilla: "Villa",
  minutes: "minutes",
  readMore: "Read More",
  newsletterTitle: "Subscribe to Our Newsletter",
  newsletterSubtitle: "Stay informed about the latest campaigns and travel tips",
  subscribe: "Subscribe",
  
  // Contact Page
  title: "Contact",
  subtitle: "How can we help you? Get in touch with us",
  phone: "Phone",
  responseTime: "Response within 24 hours",
  address: "Address",
  officeHours: "Monday - Sunday: 00:00 - 24:00",
  socialMedia: "Social Media",
  sendMessage: "Send Us a Message",
  messageSent: "Your message has been sent successfully! We will get back to you as soon as possible.",
  messageError: "An error occurred while sending the message. Please try again.",
  fullName: "Full Name",
  fullNamePlaceholder: "Your first and last name",
  subject: "Subject",
  selectSubject: "Select subject",
  tourServices: "Tour Services",
  rentalServices: "Rental Services",
  other: "Other",
  yourMessage: "Your Message",
  messagePlaceholder: "Write your message here...",
  characters: "characters",
  sending: "Sending...",
  visitUs: "Visit Us",
  visitUsSubtitle: "Come to our office, we would be happy to help you",
  formDescription: "Fill out the form for your questions, suggestions or reservation requests.",
  success: "Success!",
  successMessage: "Your message has been sent successfully. We will get back to you as soon as possible.",
  error: "Error!",
  errorMessage: "Message could not be sent. Please try again or call us directly.",
  findUs: "Find Us",
  whyChooseUs: "Why Choose Us?",
  feature1Title: "24/7 Support",
  feature1Desc: "We are always with you, you can reach us anytime.",
  feature2Title: "Professional Team",
  feature2Desc: "We provide the best service with our 6+ years experienced team.",
  feature3Title: "Reliable Service",
  feature3Desc: "Proven quality with 285K+ happy customers.",
  name: "Full Name",
  namePlaceholder: "Enter your full name",
  subjectPlaceholder: "Subject of your message",
  message: "Message",
  send: "Send Message"
};

export default enCommon;
